import React, { useMemo } from 'react';
import './_organizersBlock.scss';

const OrganizersBlock = ({ leftPadding, rightPadding, organizerData }) =>
  useMemo(() => {
    return (
      <section
        className={`organizersBlock
                         ${leftPadding ? 'leftPadding' : ''}
                         ${rightPadding ? 'rightPadding' : ''}`}
      >
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-md-12 mb-md-5'>
              <h3 className='text-center'>{'Organizers'.toUpperCase()}</h3>
            </div>
            {organizerData &&
              organizerData.map((organizer, i) => (
                <div key={i} className='col-lg-6 m-auto withBorders'>
                  <div className='row'>
                    <div className='col-lg-12 organizerAvatarBlock'>
                      <div
                        className='organizerAvatar'
                        style={{ backgroundImage: `url('${organizer.photo}')` }}
                      />
                    </div>
                    <div className='col-lg-6 organizersInfo text-uppercase text-lg-right pr-md-5'>
                      <h4
                        className='organizerName'
                        dangerouslySetInnerHTML={{ __html: organizer.name }}
                      />
                      <p className='organizerPosition'>{organizer.position}</p>
                      <p className='organizerCompany'>
                        {organizer.company_name}
                      </p>
                      <div
                        className='foundationLogo'
                        style={{
                          backgroundImage: `url('${organizer.organizer_logo}')`,
                        }}
                      />
                    </div>
                    <div className='col-lg-6 pt-md-1 px-md-3 pr-md-0 organizerText'>
                      <p dangerouslySetInnerHTML={{ __html: organizer.text }} />
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>
    );
  }, [organizerData, leftPadding, rightPadding]);

export default OrganizersBlock;
